/** Shared helpers for chat-thread comments (workflow + task dialogs). */

export const commentTime = (msg) => {
  const raw = msg?.createdAt || msg?.timestamp;
  const time = raw ? new Date(raw).getTime() : 0;
  return Number.isNaN(time) ? 0 : time;
};

export const sortComments = (list) =>
  [...(list || [])].sort((a, b) => commentTime(a) - commentTime(b));

export const commentKey = (msg) => String(msg?.id || msg?._id || msg?.tempId || '');

export const mergeComments = (...lists) => {
  const byId = new Map();
  lists.flat().forEach((msg) => {
    const key = commentKey(msg);
    if (!key) return;
    byId.set(key, { ...(byId.get(key) || {}), ...msg });
  });
  return sortComments([...byId.values()]);
};

export const removeCommentById = (list, id) =>
  (list || []).filter((msg) => commentKey(msg) !== String(id || ''));

export const collectThreadReplies = (msgs, rootId) => {
  const ids = new Set([String(rootId)]);
  let grew = true;
  while (grew) {
    grew = false;
    (msgs || []).forEach((msg) => {
      const id = commentKey(msg);
      const parent = String(msg?.replyToMessageId || '');
      if (id && parent && ids.has(parent) && !ids.has(id)) {
        ids.add(id);
        grew = true;
      }
    });
  }
  return (msgs || []).filter((msg) => {
    const id = commentKey(msg);
    return id && id !== String(rootId) && ids.has(id);
  });
};

export const htmlIsMeaningful = (html) => {
  if (!html || typeof html !== 'string') return false;
  if (html === '<p><br></p>' || html === '<p></p>') return false;
  if (/<img\b/i.test(html)) return true;
  const tmp = typeof document !== 'undefined' ? document.createElement('div') : null;
  if (tmp) {
    tmp.innerHTML = html;
    return Boolean((tmp.textContent || tmp.innerText || '').replace(/\s+/g, ' ').trim());
  }
  return html.replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim().length > 0;
};
